module.exports = __webpack_public_path__ + "static/media/surfer-gold-yeti.dc37969a.png";